module.exports = __webpack_public_path__ + "static/media/loginVideo.114880b0.m4v";